import { render, staticRenderFns } from "./meet-inform-list.vue?vue&type=template&id=2b21b6e8&scoped=true&"
import script from "./meet-inform-list.vue?vue&type=script&lang=js&"
export * from "./meet-inform-list.vue?vue&type=script&lang=js&"
import style0 from "./meet-inform-list.vue?vue&type=style&index=0&id=2b21b6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b21b6e8",
  null
  
)

export default component.exports